import "./index.scss";

import { ReactComponent as ArrowDown } from "../../../assets/images/icons/dropdown.svg";
import { ReactComponent as ArrowUp } from "../../../assets/images/icons/dropdown-up.svg";

const SortButton = ({
  label = "",
  value = "",
  sortingCallback = (sort_by, sort_order) => null,
  pageParams = { sort_by: "", sort_order: "DESC" },
  containerClass = "",
  ...restProps
}) => {
  const setClassName = () => {
    let classToReturn = "";
    if (pageParams.sort_by === value) {
      classToReturn += " highlighted";
      classToReturn += pageParams.sort_order === "DESC" ? " descending" : " ascending";
    } else {
      classToReturn = " descending";
    }
    return classToReturn;
  };

  const handleSort = () => {
    //If this label is not sorted by to begin with, sorting should start DESC
    //Otherwise invert
    let sortOrder =
      pageParams.sort_by !== value ? "DESC" : pageParams.sort_order === "DESC" ? "ASC" : "DESC";
    sortingCallback(value, sortOrder);
  };

  return (
    <label
      onClick={handleSort}
      className={`${setClassName()} sort-button-container label ${containerClass}`}
      {...restProps}
    >
      <span>{label}</span>
      {setClassName()?.includes("ascending") ? <ArrowUp /> : <ArrowDown />}
    </label>
  );
};

export default SortButton;
